import { ApiHandlerDiscreteParameter, HasOnError, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/SavedOrderDetails/Handlers/DisplayOrder";
import { CartModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        cartId: string;
    } & HasOnError,
    GetCartApiParameter,
    CartModel
>;

export const PopulateApiParameterExtended: HandlerType = props => {
    const state = props.getState();
    const currentCartId = state.pages.savedOrderDetails.cartId;
    const savedOrderState = getCartState(state, props.parameter.cartId);
    if (!savedOrderState.value?.cartLines || savedOrderState.value.cartLines.length === 0) {
        props.apiParameter = {
            cartId: props.parameter.cartId,
            expand: ["cartLines", "hiddenproducts", "restrictions"],
        } as GetCartApiParameter;
    } else {
        if (!savedOrderState.isLoading) {
            props.parameter.onError?.();
        }
        return false;
    }
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterExtended);
